import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const publicGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.getAuthState().pipe(
    take(1), // Complete after the first emission
    map(user => {
      if (user) {
        // User is logged in, redirect away from public-only pages (like login)
        // Redirect to a default authenticated page, e.g., '/ai-studio' or '/'
        // If redirecting to '/', the rootRedirectGuard will handle further redirection.
        return router.createUrlTree(['/ai-studio']);
      } else {
        // User is not logged in, allow access to the public page
        return true;
      }
    })
  );
};
